import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const AsyncConfirmEditRepeatingTaskModal = Loadable({
  loader: () => import( /* webpackChunkName: "confirm-edit-repeating-task-modal" */'./ConfirmEditRepeatingTaskModal').then(mod => mod.default),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
export default AsyncConfirmEditRepeatingTaskModal;